import { createFileRoute } from "@tanstack/react-router";

import { SettingsPage } from "@/features/Settings/SettingsPage";
import { EmailTab } from "@/features/Settings/tabs/EmailTab";

export const Route = createFileRoute("/_auth/settings/$siteId/email")({
  component: RouteComponent,
});

function RouteComponent() {
  const { siteId } = Route.useParams();

  return (
    <SettingsPage
      title="Email"
      description="Manage your sender identity, domain authentication, and deliverability."
      data-testid="settings-email-page"
    >
      <EmailTab siteId={siteId} />
    </SettingsPage>
  );
}
